import styles from "./styles/PageSection.module.css";

const PageSection = ({ title, actions, children }) => {
  return (
    <main className={styles["page-section"]}>
      <header>
        <h1>{title}</h1>
        {actions}
      </header>
      <section className={styles["page-section-content"]}>{children}</section>
    </main>
  );
};

export default PageSection;
